import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Reminder } from 'src/app/models/server/reminder';

@Injectable({
    providedIn: 'root',
})
export class RemindersStateService {
    private onRemindersListChange = new BehaviorSubject<Reminder[]>(null);

    /**
     * Emet un événement lorsque la liste des rappels change.
     */
    public get remindersListChange$() {
        return this.onRemindersListChange.asObservable();
    }

    // Retourne la liste des rappels.
    public getRemindersList(): Reminder[] {
        return this.onRemindersListChange.value;
    }

    // Spécifie la liste des rappels.
    public setRemindersList(reminders: Reminder[]) {
        this.onRemindersListChange.next(reminders);
    }
}
